import React from 'react';
import classes from 'classnames';
import styles from './index.module.less';
import {Button} from "@blueprintjs/core";
import { useHistory } from 'react-router-dom';

const CourseCard = ({ className, course }) => {
  const history = useHistory();
  const handleRedirectToDetails = () => {
    window.scrollTo({ top: 0 });
    switch (Number(course.itemId)) {
      case 1:
        history.push('/sales/python3');
        break;
      case 3:
        history.push('/sales/spider');
        break;
      case 4:
        history.push('/sales/algorithm');
        break;
      default:
        break;
    }
  };
  return (
    <div className={classes(styles['course-card'], className)}>
      <div className={styles.header}>
        <div className={styles['course-name']}>{course.name}</div>
        <div className={styles['course-info']}>
          <div>
            <span>难度：</span>
            <strong>{course.level}</strong>
          </div>
          <div>
            <span>课程长度：</span>
            <strong>{course.chapter_num}章节 {course.lesson_num}小节</strong>
          </div>
          <div>
            <span>预计学习天数：</span>
            <strong>{course.learn_day}天</strong>
          </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.content}>{course.mall_desc}</div>
        <div className={styles.extra}>
          <div className={styles.label}>赠品</div>
          <div className={styles.content}>精选练习题库｜超干货python学习资料｜专业大佬1v1答疑</div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.bought}>{course.is_buy ? '你已购买此课程' : ''}</div>
        {course.is_buy ? (
          <Button className={styles['details-button']} onClick={() => history.push(`/sales/success/${course.order_uuid}`)}>查看订单</Button>
        ) : (
          <Button className={styles['details-button']} onClick={handleRedirectToDetails}>查看详情</Button>
        )}
      </div>
    </div>
  );
};

export default CourseCard;
